import { Flex } from "components/base/container";
import { useEffect, useState } from "react";
import styled, { keyframes } from "styled-components";

const Loading: React.FC<{ loading?: boolean; noText?: boolean; [index: string]: any }> = ({ loading, noText, ...props }) => {
  const loadingTxtInitial = "LOADING NOW ...";
  const [currentCharacter, setCurrentCharacter] = useState(0);
  useEffect(() => {
    setTimeout(() => {
      setCurrentCharacter((currentCharacter + 1) % (loadingTxtInitial.length + 1));
    }, 150);
  }, [currentCharacter]);
  return (
    <>
      {loading && (
        <Flex alignCenter justifyCenter col gridGap={"30px"} {...props}>
          <LoadingItem />
          {!noText && (
            <Flex height={"1.2em"} color={"#fff3"} fontWeight={"bold"} letterSpacing={"0.1em"} lineHeight={"1.2em"}>
              {loadingTxtInitial.slice(0, currentCharacter)}
            </Flex>
          )}
        </Flex>
      )}
    </>
  );
};

const LoadingItem = styled.div`
  width: 40px;
  height: 40px;
  border: 10px solid #fff3;
  border-left-color: transparent;
  border-right-color: transparent;
  border-radius: 100%;
  animation: ${keyframes`
        from {
            transform: rotate(0deg);
        }
        to {
            transform: rotate(360deg);
        }
    `} infinite 1000ms linear;
`;

export default Loading;
